export const accumulationSignatures = (page = 1) => {
    return [
        {
            config: {
                templateConfig: {
                    x: 0.031317005132923105,
                    y: 0.04642166344294004,
                    width: 0.3710853841774252,
                    height: 0.1528046421663443,
                    page,
                },
                rectConfig: {
                    x: 24.33331298828125,
                    y: 24,
                    width: 288.3333435058594,
                    height: 79,
                    page,
                },
            },
            id: '4A354D69-1166-48F5-A800-CA599FDE7082',
            key: 'Signature',
            fieldName: 'Primary Caregiver',
            type: 'signature',
            instruction: '',
            data: {},
            required: true,
            options: {
                showTitleInPdfTemplateView: true,
            },
        },
        {
            config: {
                templateConfig: {
                    x: 0.4560274298433478,
                    y: 0.04448742746615087,
                    width: 0.34534535843739944,
                    height: 0.15667311411992263,
                    page,
                },
                rectConfig: {
                    x: 354.33331298828125,
                    y: 23,
                    width: 268.3333435058594,
                    height: 81,
                    page,
                },
            },
            id: 'D6B1015F-D3CC-49DE-BF45-1F5A031539DC',
            key: 'Signature',
            fieldName: 'Alternate Caregiver',
            type: 'signature',
            instruction: '',
            data: {},
            options: {
                showTitleInPdfTemplateView: true,
            },
            required: true,
        },
    ];
};
